<template>
  <div class="row myrow content-mb-42" v-if="$parent.$parent.rerender">
    <p class="content-s-2-label">
      <label
        >Месторасположение регионального Фонда развития промышленности:</label
      >
    </p>
    <div
      class="col-xs-12 mycol"
      v-bind:class="{
        'has-error': $parent.$parent.checkErrorField(
          'PROJECTS',
          'LOGIC',
          'UF_REGION_ID2'
        )
      }"
    >
      <select
        v-model="$parent.project.UF_REGION_ID2"
        class="sel-dropdown i-main-style i-wid-29"
        :disabled="is_disabled || $parent.$parent.projectDisabled"
        v-on:change="
          $parent.$parent.removeError('PROJECTS', 'LOGIC', 'UF_REGION_ID2')
        "
      >
        <option value=""></option>
        <option
          v-for="item in $parent.directory.regions"
          v-bind:value="item.ID"
          v-bind:key="item.ID"
          v-text="item.NAME"
        ></option>
      </select>
      <div class="error-text">
        {{
          $parent.$parent.checkErrorText("PROJECTS", "LOGIC", "UF_REGION_ID2")
        }}
      </div>
    </div>
    <div
      class="col-xs-12 mycol content-mb-14"
      v-bind:class="{
        'has-error': $parent.$parent.checkErrorField(
          'PROJECTS',
          'LOGIC',
          'UF_ID_REGION_FOND'
        )
      }"
    >
      <br />
      <p class="content-s-2-label">
        <label>
          Название регионального Фонда развития промышленности:
          <VDropdown
            tag="span"
            trigger="click"
            placement="bottom"
            popperClass="custom-popper"
            :distance="25"
            style="display: inline"
          >
            <a class="icon-help icon-help-top" />
            <template #popper>
              <div class="custom-popper-content">
                Подача заявки по совместным программам возможна только в случае
                наличия соглашения с Региональным Фондом в регионе реализации
                проекта
              </div>
            </template>
          </VDropdown>
        </label>
      </p>
      <select
        v-model="$parent.project.UF_ID_REGION_FOND"
        class="sel-dropdown i-main-style i-wid-29"
        v-on:change="
          $parent.$parent.removeError('PROJECTS', 'LOGIC', 'UF_ID_REGION_FOND')
        "
        :disabled="$parent.$parent.projectDisabled"
      >
        <option value=""></option>
        <option
          v-for="item in regionFond"
          v-bind:value="item.ID"
          v-bind:key="item.ID"
          v-text="item.NAME"
        ></option>
      </select>
      <div class="error-text">
        {{
          $parent.$parent.checkErrorText(
            "PROJECTS",
            "LOGIC",
            "UF_ID_REGION_FOND"
          )
        }}
      </div>
    </div>
  </div>
</template>

<script>
import { Dropdown as VDropdown } from "floating-vue";

export default {
  name: "uf_region_id",
  components: { VDropdown },
  props: {
    is_disabled: false
  },
  computed: {
    regionFond() {
      if (this.$parent.project.UF_REGION_ID2 < 1) {
        return [];
      }
      let t = this.$parent.directory.reg_fond_list.filter(
        c => c.ID_REGION === this.$parent.project.UF_REGION_ID2
      );
      // this.addRegionFond();
      return t;
    }
  },
  methods: {
    // addRegionFond() {
    //   let t = this.$parent.directory.reg_fond_list.filter(
    //     c => c.ID_REGION === this.$parent.project.UF_REGION_ID2
    //   );
    // if (t[0]) {
    //   this.$parent.project.UF_ID_REGION_FOND = t[0].ID;
    //   console.log("let t: ", t[0].ID, t[0].NAME);
    // } else {
    //   this.$parent.project.UF_ID_REGION_FOND = "";
    // }
    // }
  }
};
</script>

<style scoped></style>
